<template>
  <el-card shadow="never" class="aui-card--fill">
	  <el-row style="background-color: #F3F4F4;">
	  	<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
	  		<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
	  		部门管理
	  	</el-col>
	  	<el-col :xs="24" :md="18">
	  		<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
	  			<el-form-item>
	  			<el-button v-if="$hasPermission('sys:dept:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
				</el-form-item>
	  			<el-form-item>
	  				<el-button type="info" @click="getDataList()">刷新</el-button>
	  			</el-form-item>
	  		</el-form>
	  	</el-col>
	  </el-row>
    <div class="mod-sys__dept">
      <el-table v-loading="dataListLoading" :data="dataList" row-key="id" style="width: 100%;">
        <el-table-column prop="name" :label="$t('dept.name')" header-align="center" min-width="150"></el-table-column>
        <el-table-column prop="parentName" :label="$t('dept.parentName')" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sort" :label="$t('dept.sort')" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:dept:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:dept:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './dept-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/dept/list',
        deleteURL: '/sys/dept'
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>

<style lang="scss" scoped>
.mod-sys__dept {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow: auto;
  }
}
</style>